<!-- Button -->
<button
  [matMenuTriggerFor]="userActions"
  mat-icon-button>
  <span class="relative">
    <img
      *ngIf="showAvatar && user.avatar"
      [src]="user.avatar"
      class="w-7 h-7 rounded-full"
      referrerpolicy="no-referrer">
    <mat-icon
      *ngIf="!showAvatar || !user.avatar"
      [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span
      [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"
      class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
    ></span>
  </span>
</button>

<mat-menu
  #userActions="matMenu"
  [xPosition]="'before'">
  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>Sesión iniciada como:</span>
      <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
    </span>
  </button>
  <!--  <mat-divider class="my-2"></mat-divider>-->
  <!--  <button mat-menu-item>-->
  <!--    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>-->
  <!--    <span>Profile</span>-->
  <!--  </button>-->
  <!--  <button mat-menu-item>-->
  <!--    <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>-->
  <!--    <span>Settings</span>-->
  <!--  </button>-->
  <!--  <button-->
  <!--    mat-menu-item-->
  <!--    [matMenuTriggerFor]="userStatus">-->
  <!--    <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>-->
  <!--    <span>Status</span>-->
  <!--  </button>-->
  <mat-divider class="my-2"></mat-divider>
  <button
    (click)="signOut()"
    mat-menu-item>
    <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
    <span>Cerrar sesión</span>
  </button>
</mat-menu>

<mat-menu
  #userStatus="matMenu"
  class="user-status-menu">
  <button mat-menu-item>
    <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
    <span>Online</span>
  </button>
  <button mat-menu-item>
    <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
    <span>Away</span>
  </button>
  <button mat-menu-item>
    <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
    <span>Busy</span>
  </button>
  <button mat-menu-item>
    <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
    <span>Invisible</span>
  </button>
</mat-menu>
